module.exports = __webpack_public_path__ + "media/images/homes/arrow-f3004b1fbb8f38cce81c8deb30733ac1.png";